export default __webpack_public_path__ + "static/media/Filter.c654f287.svg";